/**
 * @desc 查询门店详情信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** lat */
  lat?: string;
  /** lng */
  lng?: string;
}

export interface PathParams {
  /** id */
  id: number;
}

function req(
  params: Params & PathParams,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.GeneralHttpResponse<defs.store.StoreDetailVO>>(
    `/storeapi/api/v3/store/${params.id}`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.StoreDetailVO>;
export default req;
